export default "__VITE_ASSET__CKDP835v__"